import { selectRecordingContactItem } from "./recordingContacts";
export const selectCallDetailsInitialize = (state) => state.app.historyCallDetails.initialize;
export const selectCallDetailsById = (state) => id => {
    if (!state.entities.historyCallDetails.byId[id]) {
        return null;
    }
    return Object.assign(Object.assign({}, state.entities.historyCallDetails.byId[id]), { contact: Object.assign({}, selectRecordingContactItem(state)(state.entities.historyCallDetails.byId[id].contactId)) });
};
